import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PreviewGate({ access }) {
  return (
    <section
      className="lumen-scroll-stage stage-threshold stage-access lesson-preview-gate"
      data-testid="lesson-preview-gate"
    >
      <div className="lumen-frame value-access lesson-preview-gate-shell">
        <div className="space-y-4" data-testid="lesson-preview-gate-copy">
          <p className="lumen-kicker" data-testid="lesson-preview-gate-kicker">
            Profondeur retenue
          </p>
          <h2 className="lumen-title text-3xl sm:text-4xl" data-testid="lesson-preview-gate-title">
            {access.threshold_title}
          </h2>
          <p className="lumen-copy" data-testid="lesson-preview-gate-text">
            {access.threshold_copy}
          </p>
        </div>

        <div className="lesson-preview-structure" data-testid="lesson-preview-structure">
          {access.sequence_titles.map((title, index) => (
            <div className="lesson-preview-structure-item" key={title} data-testid={`lesson-preview-structure-item-${index + 1}`}>
              <span className="lumen-panel-kicker">Séquence {String(index + 1).padStart(2, "0")}</span>
              <span>{title}</span>
            </div>
          ))}
        </div>

        <div className="lesson-preview-gate-actions" data-testid="lesson-preview-gate-actions">
          <Button asChild className="lumen-gold-button" data-testid="lesson-preview-primary-button">
            <Link to="/entrer">
              {access.primary_offer_id === "lumen-integral" ? "Franchir le corpus vivant" : "Entrer dans LUMEN"}
              <ArrowRight />
            </Link>
          </Button>
          <Button asChild className="lumen-outline-button" data-testid="lesson-preview-secondary-button" variant="outline">
            <Link to="/parcours">
              Revenir à la carte du cycle
              <ArrowRight />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}